import React from 'react'
import { history } from '../store'

class UpdateList extends React.Component {
  goTo(id, e) {
    history.push(`/updates/${id}`)
  }

  render() {
    if (!this.props.updates) {
      return null
    }

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Factura</th>
              <th scope="col">Máquina</th>
              <th scope="col">Estado</th>
              <th scope="col">Fecha</th>
              <th scope="col">Locker</th>
              <th scope="col">Matrícula</th>
            </tr>
          </thead>
          <tbody>
            {this.props.updates.map(update => (
              <tr key={update._id} onClick={e => this.goTo(update._id, e)}>
                <td>{update.Invoice}</td>
                <td>{update.Machine}</td>
                <td>{update.Status}</td>
                <td>{new Date(update.TimeStamp).toLocaleString()}</td>
                <td>{update.Locker}</td>
                <td>{update.Matricula}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default UpdateList
